import ModalDetailRequest from '@/components/request/ModalDetailRequest'
import RequestActive from '@/pages/request/RequestActive'
import RequestCompleted from '@/pages/request/RequestCompleted'
import { RouteObject } from 'react-router-dom'
import ModalDetailCompletedRequest from '@/components/request/ModalDetailCompletedRequest'

const myRequestRoutes: RouteObject[] = [
  {
    path: 'my-request',
    children: [
      {
        path: 'active',
        element: <RequestActive />,
        children: [{ path: ':processKey/:id', element: <ModalDetailRequest /> }],
      },
      {
        path: 'completed',
        element: <RequestCompleted />,
        children: [{ path: ':processKey/:id', element: <ModalDetailCompletedRequest /> }],
      },
    ],
  },
]

export default myRequestRoutes
